<div class="inner-l statistics-information__container">
    <span class="vertical-ruler-left bg-grey" [ngClass]="{ 'vertical-ruler vertical-ruler-1': noRuler === false }"></span>
    <span>{{title}}</span><br>
    <span class="statistics-information__value">{{value}}</span>
</div>
